// Phase 1A Phase 9C.10a — BriefShell premium-rails sibling.
//
// Token-only sibling overlay. Adds the 9C premium chrome vocabulary
// (cardLow elevation, transitionStandard motion, headerLead +
// navItemLead icon-row anchors) without expanding the parent
// `brief-shell.styles.ts` file. Consumers continue to import the
// existing chrome from the parent file and spread these rails on
// top where needed.
//
// Trust contract:
//   - No raw hex/rgb. No icons. No emoji.
//   - cardLow + transitionStandard come from the canonical 9C
//     elevation + motion helpers.
//   - No glow, no fake live pulse, no selected-card amber ring.

import type { CSSProperties } from "react";

import { cardLow } from "../../styles/elevation.ts";
import { transitionStandard } from "../../styles/motion.ts";

// ─── Article elevation ──────────────────────────────────────────
//
// Spread on top of the parent file's `article` constant so the Brief
// dossier sits on the same visual plane as the 9C /home, /vault, and
// /exchange premium surfaces. The 640px-centered single-column
// dossier framing (UI-architecture §5) is preserved by the parent.

export const articleRails: CSSProperties = {
  ...cardLow,
  ...transitionStandard,
  background: "var(--sz-bg-surface)",
  border: "1px solid var(--sz-border-subtle)",
  borderRadius: "var(--sz-radius-lg)",
  padding: "var(--sz-space-6)",
};

// ─── Header / nav-item lead rows ────────────────────────────────
//
// Inline-flex anchors so the registered icons sit directly beside
// the existing eyebrow / nav-link labels.

export const headerLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-amber-text)",
};

export const navItemLead: CSSProperties = {
  ...transitionStandard,
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
};
